import { useTranslation } from 'react-i18next';

/**
 * Relative "time ago" formatter for print-station surfaces.
 *
 * Shared by PrintStationPage (Recently Printed) and ResolvedIssuesPanel so the
 * two never drift. Relies on i18next `_one`/`_other` plural selection — the
 * caller passes `{ count }` and i18next picks the right form from the `time.*`
 * keys in the common namespace. Do NOT hand-append `_other`; that hard-codes the
 * plural and mis-renders the singular (e.g. "1m ago" would read from `_other`).
 */
export function useFormatTimeAgo() {
  const { t } = useTranslation('common');
  return function formatTimeAgo(isoString: string): string {
    const diff = Date.now() - new Date(isoString).getTime();
    const minutes = Math.floor(diff / 60_000);
    if (minutes < 1) return t('time.justNow');
    if (minutes < 60) return t('time.minutesAgo', { count: minutes });
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return t('time.hoursAgo', { count: hours });
    return t('time.daysAgo', { count: Math.floor(hours / 24) });
  };
}
